const toggleSidebar = () => {
  const openButton = document.getElementById("small-sidebar-open-button")
  const closeButton = document.getElementById("small-sidebar-close-button")
  const sidebar = document.getElementById("small-sidebar")
  const wrapper = document.getElementById("page-wrapper")

  if (openButton?.classList.contains("visible")) {
    openButton?.classList.remove("visible", "opacity-0", "z-10")
    closeButton?.classList.remove("!opacity-100", "z-20")
    sidebar?.classList.remove(
      "max-lg:!h-full",
      "[&_.small-sidebar-transition-group]:top-0",
      "[&_.small-sidebar-transition-group]:opacity-100",
    )
    wrapper?.classList.remove("max-lg:!h-full", "max-lg:overflow-hidden")
  } else {
    openButton?.classList.add("visible", "opacity-0", "z-10")
    closeButton?.classList.add("!opacity-100", "z-20")
    sidebar?.classList.add(
      "max-lg:!h-full",
      "[&_.small-sidebar-transition-group]:top-0",
      "[&_.small-sidebar-transition-group]:opacity-100",
    )
    wrapper?.classList.add("max-lg:!h-full", "max-lg:overflow-hidden")
  }
}

export default async () => {
  const openButton = document.getElementById("small-sidebar-open-button")
  const closeButton = document.getElementById("small-sidebar-close-button")
  const regionDropdown = document.getElementById("small-region-select-dropdown")

  regionDropdown?.addEventListener("change", (event) => {
    window.location = event.target.value
  })

  openButton?.addEventListener("click", toggleSidebar)
  closeButton?.addEventListener("click", toggleSidebar)
}
